import { guideSteps } from "@/mocks/home";

export default function GuideSection() {
  return (
    <section id="guide" className="border-t border-background-200 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
            使用指南
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            从打开地址到顺畅播放的完整流程
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            第一次使用的用户，按下面六个步骤操作即可完成从进入到播放的全过程，
            也能知道遇到打不开时该怎么处理。
          </p>
        </div>

        <ol className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {guideSteps.map((item) => (
            <li
              key={item.step}
              className="relative flex gap-4 rounded-xl border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg text-background-50">
                {item.step}
              </span>
              <div>
                <h3 className="font-heading text-base text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}